const telegramLink = "https://t.me/bytorg_bot";
const viberLink = "https://viber.click/375296380608";

export { telegramLink, viberLink };
